export const joinCssDeclarations = (declarations: string[]) => {
  return declarations.join('; ')
}
